// Default Nama Penerima & Lokasi Gudang menurut Jenis Barang (MBarang.JenisBarang) pada PO.
// Hanya terisi bila SEMUA barang PO sejenis; PO campuran Material + Logistik dibiarkan kosong
// supaya penerima memilih sendiri.
const DEFAULT_PENERIMA = {
  Material: { NamaPenerima: "Arbani Sandi", LokasiGudang: "Gudang Material" },
  Logistik: { NamaPenerima: "Abdi Stio Pangestu", LokasiGudang: "Gudang Logistik" },
};

export const defaultPenerimaDariItem = (items) => {
  const jenis = new Set(
    (items || []).map((i) => (i.JenisBarang || "").trim()).filter(Boolean)
  );
  if (jenis.size !== 1) return null;
  return DEFAULT_PENERIMA[[...jenis][0]] || null;
};
